import { AppTheme } from '@gv/triage-components';

export const getCardStyles = (theme: AppTheme) => ({
  invalid: {
    color: theme.config.text.red,
    iconColor: theme.config.text.red,
  },
  base: {
    color: theme.config.text.primary,
    iconColor: theme.config.text.primary,
    '::placeholder': {
      color: theme.config.input.placeholder,
    },
  },
});
